// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerHeader__g2gIc {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 5px;
  width: 100%;
  flex-wrap: nowrap;
  /* Previne animações/transições que causam "pulo" na tela */
  will-change: auto;
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* Remove animações apenas do Autocomplete (que usa placeholder) */
.styles_containerHeader__g2gIc .MuiAutocomplete-root {
  transition: none !important;
}

.styles_containerHeader__g2gIc .MuiAutocomplete-root .MuiOutlinedInput-root {
  transition: none !important;
}

.styles_filtrosEsquerda__WhcOx {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  min-width: 0;
}

.styles_filtroItem__kjNSW {
  flex-shrink: 0;
}

.styles_filtrosDireita__-7-sV {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .styles_containerHeader__g2gIc {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_filtrosEsquerda__WhcOx {
    flex-wrap: wrap;
  }

  .styles_filtrosDireita__-7-sV {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/StepsAnalisar/AjusteVerbas/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,2DAA2D;EAC3D,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".containerHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 5px;\n  width: 100%;\n  flex-wrap: nowrap;\n  /* Previne animações/transições que causam \"pulo\" na tela */\n  will-change: auto;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n/* Remove animações apenas do Autocomplete (que usa placeholder) */\n.containerHeader :global(.MuiAutocomplete-root) {\n  transition: none !important;\n}\n\n.containerHeader :global(.MuiAutocomplete-root .MuiOutlinedInput-root) {\n  transition: none !important;\n}\n\n.filtrosEsquerda {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.filtroItem {\n  flex-shrink: 0;\n}\n\n.filtrosDireita {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n@media (max-width: 900px) {\n  .containerHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filtrosEsquerda {\n    flex-wrap: wrap;\n  }\n\n  .filtrosDireita {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerHeader": `styles_containerHeader__g2gIc`,
	"filtrosEsquerda": `styles_filtrosEsquerda__WhcOx`,
	"filtroItem": `styles_filtroItem__kjNSW`,
	"filtrosDireita": `styles_filtrosDireita__-7-sV`
};
export default ___CSS_LOADER_EXPORT___;
